import React, { useCallback, useState } from 'react';
import { Button, InputAdornment, IconButton, OutlinedInput, InputLabel, FormControl, Box, Alert } from '@mui/material';
import { formStyle } from '../styles';
import { useNavigate } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const HandleEditForm = ({ handleSubmit, handle, handleHandleChange }) => {
    const navigate = useNavigate();
    const [changed, setChanged] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleHandleHandleChange = useCallback((e) => {
        handleHandleChange({ ...handle, handle: e.target.value });
        setChanged(true);
    }, [handle, handleHandleChange]);

    const handlePasswordChange = useCallback((e) => {
        handleHandleChange({ ...handle, password: e.target.value });
        setChanged(true);
    }, [handle, handleHandleChange]);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = event => {
        event.preventDefault();
    };


    return (
        <form style={formStyle}>
            <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-handle">Handle</InputLabel>
                <OutlinedInput
                    id="outlined-handle"
                    type='text'
                    value={handle?.handle || ""}
                    onChange={handleHandleHandleChange}
                    label="Handle"
                    error={!handle?.handle}
                    autoFocus
                />
            </FormControl>
            
            <Box sx={{ height: 20 }} />
            
            <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    value={handle?.password || ""}
                    onChange={handlePasswordChange}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    }
                    label="Password"
                    error={!handle?.password}
                />
            </FormControl>

            {(!handle?.handle || !handle?.password) && (
                <Alert severity="error" sx={{ mt: 2, mb: 2 }}>
                    Handle and Password are required
                </Alert>
            )}

            <Box sx={{ display: 'flex', alignSelf : 'center', gap: 2, mt: 4 }}>
                <Button 
                    type="submit" 
                    variant="contained" 
                    onClick={handleSubmit} 
                    disabled={!changed || !handle?.handle || !handle.password} 
                    size="large"
                    sx={{ minWidth: 120 }}
                >
                    Save
                </Button>
                <Button 
                    variant="outlined" 
                    onClick={() => navigate('/handles')} 
                    size="large"
                    sx={{ minWidth: 120 }}
                >
                    Cancel
                </Button>
            </Box>
        </form>
    );
};

export default HandleEditForm;